import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PrintVoucherDialogStore } from './print-voucher-dialog.store';
import { fb } from '../../../../modules/shared/shared.global-service';
import { BaseDialogComponent } from '../../../kit/base-dialog/base-dialog.component';
import { ActionButtonsComponent } from '../../../kit/action-buttons/action-buttons.component';
import { CheckInputComponent } from '../../../kit/input/check-input/check-input.component';
import { generateFilename } from '../../../../utils/files.utils';

@Component({
    selector: 'app-print-voucher-dialog',
    templateUrl: 'print-voucher-dialog.component.html',
    styleUrl: 'print-voucher-dialog.component.scss',
    providers: [PrintVoucherDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ActionButtonsComponent,
        CheckInputComponent,
    ],
})
export class PrintVoucherDialogComponent extends BaseDialogComponent {

    public store = inject(PrintVoucherDialogStore);

    protected form = fb.group({
        archive: fb.control<boolean>(true),
        front: fb.control<boolean>(true),
        back: fb.control<boolean>(false),
    });

    protected loading = false;

    public override async save(): Promise<void> {
        if (this.loading) return;

        this.loading = true;
        try {
            const started = await this.store.start({
                archive: this.form.value.archive ?? false,
                front: this.form.value.front ?? false,
                back: this.form.value.back ?? false,
                voucherIds: this.dialogConfig.data.voucherIds,
                filename: generateFilename('voucher.label'),
            });
            if (started) this.dialogRef.close(true);
        } finally {
            this.loading = false;
        }
    }

}
